import type { ClientStage } from './generated/gql-enums';

export const CLIENT_STAGE_ACCOUNT_SETUP_FLOW = 'account_setup_flow' satisfies ClientStage;
export const CLIENT_STAGE_FULLY_ONBOARDED = 'fully_onboarded' satisfies ClientStage;
export const CLIENT_STAGE_INTAKE_FLOW = 'intake_flow' satisfies ClientStage;
export const CLIENT_STAGE_ONBOARDING_FLOW = 'onboarding_flow' satisfies ClientStage;
export const CLIENT_STAGE_POST_INTAKE_WAITING_AREA = 'post_intake_waiting_area' satisfies ClientStage;
export const CLIENT_STAGE_POST_ONBOARDING_WAITING_AREA = 'post_onboarding_waiting_area' satisfies ClientStage;
